import NavBar from "../NavBar/navbar";
import React, { useState, useContext, useEffect, useRef } from 'react';
import { Table, Form, Input } from "antd";
import { Form as FormR } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { SearchOutlined } from '@ant-design/icons';
import './customerlistview.css';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Modal from 'react-bootstrap/Modal';
import {Button} from 'react-bootstrap';
import { Tooltip } from "antd";
import { canAccessPage, getTokenEmail, getTokenUser } from "../../helper/token";
import AxiosHelper from "../../helper/axios-helper";


function CustomerListView (){
    //#region State Management
    const [loggedInUser] = useState(getTokenUser());
    const tooltipColour = '#274D68'
    const [accountManagerDropdownOptions,setAccountManagerDropdownOptions] = useState([]);
    //#region State Management
    const ACCOUNT_EMAIL = process.env.REACT_APP_ACCOUNTS_EMAIL;
    const [tableDataSource,setDataSource] = useState([]);
    const[tableSize] = useState("col-12");
    const [customerFilters, setCustomerFilter] = useState([]);
    const [paymentTerms, setPaymentTerms] = useState([]);
    const [pageSize, setPageSize] = useState(100);
    const [currentPage, setCurrentPage] = useState(1);

    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [additionalContactDeleteModalShow, setAdditionalContactDeleteModalShow] = useState(false);
    
    const [selectedDeleteCustomer, setSelectedDeleteCustomer] = useState("");
    const [selectedDeleteAdditionalContact, setSelectedDeleteAdditionalContact] = useState("");

    const navigate = useNavigate();
    const [cancelModalShow, setCancelModalShow] = useState(false);
    const [cancelCustomerAdditionalContactsModalShow, setCancelCustomerAdditionalContactsModalShow] = useState(false);
    const [manageAdditionalContactsModalShow, setManageAdditionalContactsModalShow] = useState(false);
    const [selectedManageCustomerAdditionalContacts, setSelectedManageCustomerAdditionalContacts] = useState("");

    const [additionalContacts, setAdditionalContacts] = useState([]);
    const [currentCustomerExist,setCurrentCustomerExist] = useState([]);

    const [addContactDetails, setAddContactDetails] = useState([]);

    const [statusSelectedFilters, setStatusSelectedFilters] = useState(['Active']);
    const [statusFilters] = useState([{
        text: "Active",
        value: "Active",
      },
      {
        text: "Inactive",
        value: "Inactive",
      }]);
    const [customerSelectedFilters, setCustomerSelectedFilters] = useState([]);
    //#endregion

    //#region Table column definitions
    const CustomerColumns = [
        {
            title:"Id",
            dataIndex:"customer_name",
            render: (text, record, index) =>{ 

                return (
                    <div style={{minWidth: "15px"}}>
                        <p>{record.key}</p>
                    </div>  
                )
            }
        },
        {
            title:"Customer Name",
            dataIndex:"customer_name",
            filters: customerFilters,
            filterSearch: true,
            filteredValue: customerSelectedFilters,
            onFilter: (value, record) => record.customer_name.startsWith(value),
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? 'blue' : '#000000',fontSize: '16px' }} />,
            render: (text, record, index) =>{ 
                let isValid = true;
          
                if(record.customer_name==="-"){
                    isValid = false;
                }

                //testing duplicate names
                if (tableDataSource.filter((tableCustomer) => tableCustomer.customer_name === record.customer_name).length > 1) {
                    isValid = false;
                }

                return (
                    <div style={{minWidth: "150px", display: "flex", position:"relative"}}>
                        {!isValid && 
                            <Tooltip title="Customer name should be unique, and can't be '-'." color="#f88d8d">
                                <p className={"exclamation"}>!</p>
                            </Tooltip>
                        }
                        <FormR.Control 
                        className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`}
                        size="sm" 
                        type="text" 
                        defaultValue={record.customer_name} 
                        onBlur={(e) => handleCustNameChange(e, record)}
                        ></FormR.Control>
                    </div>  
                )
            }
        },
        {
            title:"Registration Number",
            dataIndex:"customer_registration_number",
            render: (text, record, index) => {
                let isValid = true;
          
                if(record.customer_registration_number==="-"){
                    isValid = false;
                }

                return(
                    <div style={{minWidth: "150px", display: "flex", position:"relative"}}>
                        {!isValid && 
                            <Tooltip title="Registration number can't be '-'." color="#f88d8d">
                                <p className={"exclamation"}>!</p>
                            </Tooltip>
                        }
                        <FormR.Control 
                            className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`}
                            size="sm" 
                            type="text" 
                            defaultValue={record.customer_registration_number} 
                            onBlur={(e) => handleCustRegistrationNumberChange(e, record)}
                        ></FormR.Control>
                    </div> 
                );
            }
                
        },
        {
            title:"Address",
            dataIndex:"customer_address",
            render: (text, record, index) => {
                let isValid = true;
          
                if(record.customer_address==="-"){
                    isValid = false;
                }
                return(
                    <div style={{minWidth: "150px", display: "flex", position:"relative"}}>
                        {!isValid && 
                            <Tooltip title="Customer address can't be '-'." color="#f88d8d">
                                <p className={"exclamation"}>!</p>
                            </Tooltip>
                        }
                        <FormR.Control 
                            className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`}
                            size="sm" 
                            type="text" 
                            defaultValue={record.customer_address} 
                            onBlur={(e) => handleCustAddressChange(e, record)}
                        ></FormR.Control>
                    </div> 
                );
            }
        },
        {
            title:"Vat Number",
            dataIndex:"customer_vat_number",
            render: (text, record, index) => {
                let isValid = true;
          
                if(record.customer_vat_number==="-"){
                    isValid = false;
                }

                return (
                <div style={{minWidth: "150px", display: "flex", position:"relative"}}>
                    {!isValid && 
                        <Tooltip title="Vat number can't be '-'." color="#f88d8d">
                            <p className={"exclamation"}>!</p>
                        </Tooltip>
                    }

                    <FormR.Control 
                        className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`}
                        size="sm" 
                        type="text" 
                        defaultValue={record.customer_vat_number} 
                        onBlur={(e) => handleCustVatNumberChange(e, record)}
                    ></FormR.Control>
                </div> 
                );
            }
        },
        {
            title:"Email Address",
            dataIndex:"customer_email_address",
            render: (text, record, index) => {
                let isValid = true;
          
                if(record.customer_email_address==="-"){
                    isValid = false;
                }

                if(!(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(record.customer_email_address))){
                    isValid = false;
                }

                return (
                    <div style={{minWidth: "150px", display: "flex", position:"relative"}}>
                        {!isValid && 
                            <Tooltip title="Customer email should be valid, and can't be '-'." color="#f88d8d">
                                <p className={"exclamation"}>!</p>
                            </Tooltip>
                        }   
                        <FormR.Control 
                            className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`}
                            size="sm" 
                            type="text" 
                            defaultValue={record.customer_email_address} 
                            onBlur={(e) => handleCustEmailChange(e, record)}
                        ></FormR.Control>
                    </div> 
                )
            }
        },
        {
            title:"Account Manager",
            dataIndex:"customer_account_manager",
            render: (text, record, index) => {
              let isValid = true;
              if(record.customer_account_manager===-1 || record.customer_account_manager_name === '-'){
                isValid = false;
              } 
              return (
                <div className="dropdown" style={{width: '130px', display: "flex", position:"relative"}}>
                  {!isValid && 
                    <Tooltip title="Please select an account manager. Can't be '-'." color="#f88d8d">
                      <p className={"exclamation"}>!</p>
                    </Tooltip>
                  }
                  <Tooltip title={record.customer_account_manager_name} color={tooltipColour}>
                    <FormR.Select 
                      size="sm" 
                      defaultValue={record.customer_account_manager} 
                      onChange={(e) => handleCustomerAccountManagerChange(e, record)}
                      className={`${!isValid ? 'invalid-cell' : ''}`}
                    >
                        {accountManagerDropdownOptions.map((x) => (
                            <option value={x.id}>{x.name}</option>
                        ))}
                    </FormR.Select>
                  </Tooltip>
                </div>
              );
            },
        },
        {
            title:"Contact(s)",
            render: (text, record, index) => 
                <div>
                    <Button size="sm" variant="primary" onClick={() => getCustomerAdditionalContacts(record)}>
                        Manage
                    </Button>
                </div> 
        },
        {
            title:"Payment Terms",
            dataIndex:"customer_payment_terms",
            render: (text, record, index) => 
                <div className="dropdown" style={{width: '105px'}}>
                    <FormR.Select size="sm" defaultValue={record.customer_payment_term_id} onChange={(e) => handleCustPaymentTermDropdownChange(e, record)}>
                        {paymentTerms.map((x) => (
                            <option value={x.PaymentTermId}>{x.PaymentTermDescription} days</option>
                        ))}
                    </FormR.Select>
                </div>
        },
        {
            title:"Status",
            dataIndex:"customer_status",
            filters: statusFilters,
            filterSearch: true,
            filteredValue: statusSelectedFilters,
            onFilter: (value, record) => record.customer_status.startsWith(value),
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? 'blue' : '#000000',fontSize: '16px' }} />,
            render: (text, record, index) => 
                <div className="dropdown" style={{width: '105px'}}>
                    <FormR.Select size="sm" defaultValue={record.customer_status} onChange={(e) => handleCustStatusDropdownChange(e, record)}>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                    </FormR.Select>
                </div>          
        },
        {
            title:"Actions",
            render: (record) => <img className="delete-icon" src={require('./delete.png')} alt="Not Found!" onClick={() => handleDeleteModalShow(record)}/>,
    }]

    const AdditionalContactColumns = [{
            title:"Full Name",
            dataIndex:"additional_contact_full_name",
            render: (text, record, index) =>{
                let isValid = true;
          
                if(record.additional_contact_full_name==="-" || record.additional_contact_full_name===""){
                    isValid = false;
                }

                return(
                    <div style={{display: "flex", position:"relative"}}>
                        {!isValid && 
                            <Tooltip title="Contact full name can't be '-' or empty." color="#f88d8d">
                                <p className={"exclamation"}>!</p>
                            </Tooltip>
                        }  
                        <FormR.Control 
                            className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`}
                            size="sm" 
                            type="text" 
                            defaultValue={record.additional_contact_full_name} 
                            onBlur={(e) => handleCustAdditionalNameChange(e, record)}
                        ></FormR.Control>
                    </div>  
                )
            }
          },
          {
            title:"Mobile Number",
            dataIndex:"additional_contact_mobile_number",
            render: (text, record, index) => {
                let isValid = true;
          
                if(record.additional_contact_mobile_number === "-" || record.additional_contact_mobile_number === ""){
                    isValid = false;
                }

                return(
                    <div style={{display: "flex", position:"relative"}}>
                        {!isValid && 
                            <Tooltip title="Contact full name can't be '-' or empty." color="#f88d8d">
                                <p className={"exclamation"}>!</p>
                            </Tooltip>
                        }  
                        <FormR.Control 
                            className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`}
                            size="sm" 
                            type="text" 
                            defaultValue={record.additional_contact_mobile_number} 
                            onBlur={(e) => handleCustAdditionalNumberChange(e, record)}
                        ></FormR.Control>
                    </div>  
                )
            }
          },
          {
            title:"Email Address",
            dataIndex:"additional_contact_email_address",
            render: (text, record, index) => {
                let isValid = true;
          
                if(record.additional_contact_email_address === "-" || record.additional_contact_email_address === ""){
                    isValid = false;
                }

                isValid = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(record.additional_contact_email_address);

                return(
                    <div style={{display: "flex", position:"relative"}}>
                        {!isValid && 
                            <Tooltip title="Contact email address should be valid, and can't be '-' or empty." color="#f88d8d">
                                <p className={"exclamation"}>!</p>
                            </Tooltip>
                        }  
                        <FormR.Control 
                            className={`editable-cell-input ${!isValid ? 'invalid-cell' : ''}`} 
                            size="sm" 
                            type="text" 
                            defaultValue={record.additional_contact_email_address} 
                            onBlur={(e) => handleCustAdditionalEmailChange(e, record)}
                        ></FormR.Control>
                    </div>  
                )
            }
          },
          {
              title:"Actions",
              render: (record) => <img className="delete-icon" src={require('./delete.png')} onClick={() => handleAdditionalContactDeleteModalShow(record)} alt="Not Found!"/>,
          }];

    //#endregion

    //#region Local Variables
    const EditableContext = React.createContext(null);
        

    const EditableRow = ({ index, ...props }) => {
        const [form] = Form.useForm();
        return (
            <Form form={form} component={false}>
                <EditableContext.Provider value={form}>
                    <tr {...props} />
                </EditableContext.Provider>
            </Form>
        );
    };

    const EditableCell = ({
        title,
        editable,
        children,
        dataIndex,
        record,
        handleSave,
        ...restProps
        }) => {
            const [editing, setEditing] = useState(false);
            const inputRef = useRef(null);
            const form = useContext(EditableContext);
            useEffect(() => {
                if (editing) {
                    inputRef.current.focus();
                }
            }, [editing]);
            const toggleEdit = () => {
                setEditing(!editing);
                form.setFieldsValue({
                    [dataIndex]: record[dataIndex],
                });
            };
            const save = async () => {
                try {
                    const values = await form.validateFields();
                    toggleEdit();
                    onTableDataChange(true);
        handleSave({
                        ...record,
                        ...values,
                });
                } catch (errInfo) {
                    console.log('Save failed:', errInfo);
                }
            };
            let childNode = children;
            if (editable) {
                childNode = editing ? (
                <Form.Item
                    style={{
                        margin: 0,
                    }}
                    name={dataIndex}
                    rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                    ]}
                >
                    <Input ref={inputRef} onPressEnter={save} onBlur={save} />
                </Form.Item>
                ) : (
                <div
                    className="editable-cell-value-wrap"
                    style={{
                        paddingRight: 24,
                    }}
                    onClick={toggleEdit}
                >
                    {children}
                </div>
                );
            }
        return <td {...restProps}>{childNode}</td>;
    };

    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };

    const customerColumns = CustomerColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });

    //#endregion

    //#region Functions

    function onAdditionalContactDelete(deleteAdditionalContact)
    {
        let addContactDetailsCopy = [...addContactDetails];
        let deleteAdditionalContactIndex = addContactDetailsCopy.findIndex(x => x.key === deleteAdditionalContact.key);

        if (deleteAdditionalContact.additional_contact_type === "server") 
        {
            AxiosHelper.makeAxiosRequest("Delete", "Customer", "DeleteAdditionalContacts", {AdditionalContactId: deleteAdditionalContact.key, currentUserId: loggedInUser}, null)
            .then((response) => {
                addContactDetailsCopy.splice(deleteAdditionalContactIndex, 1);
                setAddContactDetails(addContactDetailsCopy);
                notifySuccessful("Additional Contact Deleted!");
                handleAdditionalContactDeleteModalClose();
            })
            .catch(error => {
                console.log(error);
                notifyFailed("An Error Occurred, Please Try Again.");
                handleAdditionalContactDeleteModalClose();
            });  
        } 
        else 
        {
            addContactDetailsCopy.splice(deleteAdditionalContactIndex, 1);
            setAddContactDetails(addContactDetailsCopy);
            notifySuccessful("Additional Contact Deleted!");
            handleAdditionalContactDeleteModalClose();
        }
    };

    function additionalContactsValidation(){
        let isValid = true;
        //cannot save if there are no contacts
        if(addContactDetails.length === 0){
            isValid = false;
        }
        //verify all fields of each contact
        addContactDetails.forEach(additionalContact =>{
            //test for empty fields
            if(additionalContact.additional_contact_full_name==="-" || additionalContact.additional_contact_mobile_number==="-" || additionalContact.additional_contact_email_address==="-"){
                isValid=false;
            }
            //validate email
            isValid = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(additionalContact.additional_contact_email_address)
        })
        

        return isValid;
    }

    function handleCustomerAdditionalContactSave()
    {
        if(additionalContactsValidation()){
            let isSuccessfulSave = true;
            let tempAdditionalContact = {};
            let prevAdditionalContacts = [...additionalContacts];
            let newAdditionalContacts = [];
            addContactDetails.forEach(customerAdditionalContact => {

                if (customerAdditionalContact.additional_contact_type === "server") 
                {
                    tempAdditionalContact =  {
                    additionalContactId: customerAdditionalContact.key,
                    additionalContactFullName: customerAdditionalContact.additional_contact_full_name,
                    additionalContactMobileNumber: customerAdditionalContact.additional_contact_mobile_number,
                    additionalContactEmailAddress: customerAdditionalContact.additional_contact_email_address,
                    additionalContactType: customerAdditionalContact.additional_contact_type};
                } 
                else 
                {
                    tempAdditionalContact =  {
                        key: customerAdditionalContact.key,
                        customerId: selectedManageCustomerAdditionalContacts.key,
                        additionalContactFullName: customerAdditionalContact.additional_contact_full_name,
                        additionalContactMobileNumber: customerAdditionalContact.additional_contact_mobile_number,
                        additionalContactEmailAddress: customerAdditionalContact.additional_contact_email_address,
                        additionalContactType: customerAdditionalContact.additional_contact_type
                    };
                }

                //if the customer that additional contacts are added to already exists, make updates to database otherwise add additional contacts to state variable
                if(currentCustomerExist){
                    AxiosHelper.makeAxiosRequest("Create", "Customer", "SaveAdditionalContact", {currentUserId: loggedInUser}, tempAdditionalContact)
                    .then((response) => {})
                    .catch(error => {
                        console.log(error);
                        isSuccessfulSave = false;
                        notifyFailed("An Error Occured, Please Try Again.");
                        handleManageAdditionalContactsModalClose();
                    });
                }else{
                    newAdditionalContacts.push(tempAdditionalContact);
                }

            });

            //remove all instances of customerId in newAdditionalContacts from prevAdditionalContacts
            let tempPrevAdditionalContacts = [];
            prevAdditionalContacts.forEach(contact=>{
                if(newAdditionalContacts.findIndex((item)=>item.customerId===contact.customerId)===-1){
                    tempPrevAdditionalContacts.push(contact);
                }
            })

            newAdditionalContacts.forEach(contact =>{
                tempPrevAdditionalContacts.push(contact);
            })

            console.log(tempPrevAdditionalContacts);

            setAdditionalContacts(tempPrevAdditionalContacts);
            if (isSuccessfulSave) 
            {
                notifySuccessful("Customer additional contacts successfully updated!");
                handleManageAdditionalContactsModalClose();
            }
        }else{
            notifyFailed("Please ensure the contact details are valid, with at least one contact");
        }
    }

    const handleAdditionalContactAdd = () => {

        let newRowKey = GetNewRowKey(addContactDetails);
       
        const newData ={
            key: newRowKey,
            additionalContactId: null,
            custId: selectedManageCustomerAdditionalContacts.key,
            additional_contact_full_name: "-",
            additional_contact_mobile_number: "-",
            additional_contact_email_address: "-",
            additional_contact_type: "client"
        }
        
        setAddContactDetails([...addContactDetails, newData]);
    };

    function GetNewRowKey(listItems) {
        let biggestKey = 0;

        listItems.forEach(element => {
            if(element.key > biggestKey)
            {
                biggestKey = element.key;
            }
        });

        biggestKey = biggestKey+1;

        return biggestKey;
    }

        //#region Customer Handle Change Functions

        const handleCustNameChange = (e, row) => {
            row.customer_name = e.target.value;
            handleSave(row);
            onTableDataChange(true);
          }

        const handleCustRegistrationNumberChange = (e, row) => {
            row.customer_registration_number = e.target.value;
            handleSave(row);
            onTableDataChange(true);
        }

        const handleCustAddressChange = (e, row) => {
            row.customer_address = e.target.value;
            handleSave(row);
            onTableDataChange(true);
        }

        const handleCustVatNumberChange = (e, row) => {
            row.customer_vat_number = e.target.value;
            handleSave(row);
            onTableDataChange(true);
        }

        const handleCustEmailChange = (e, row) => {
            row.customer_email_address = e.target.value;
            handleSave(row);
            onTableDataChange(true);
        }

        const handleCustPaymentTermDropdownChange = (e, row) => {
            row.customer_payment_term_id = Number(e.target.value);
            handleSave(row);
            onTableDataChange(true);
        }

        const handleCustStatusDropdownChange = (e, row) => {
            row.customer_status = e.target.value;
            handleSave(row);
            onTableDataChange(true);
        }

        //#endregion

        //#region Additional Contact Handle Change Functions

        const handleCustAdditionalNameChange = (e, row) => {
            row.additional_contact_full_name = e.target.value;
            handleAdditionalSave(row);
          }

        const handleCustAdditionalNumberChange = (e, row) => {
            row.additional_contact_mobile_number = e.target.value;
            handleAdditionalSave(row);
        }

        const handleCustAdditionalEmailChange = (e, row) => {
            row.additional_contact_email_address = e.target.value;
            handleAdditionalSave(row);
        }

        const handleCustomerAccountManagerChange = (e, row) =>{
            let accountManagerId = e.target.value;
            let selectedIndex = e.target.selectedIndex;
            let accountManagerName = e.target.options[selectedIndex].text;


            row.customer_account_manager = accountManagerId;
            row.customer_account_manager_name = accountManagerName;
            handleSave(row);
            onTableDataChange(true);
          }
        //#endregion

    const onChange = (page,filter,sorter) => {
        setStatusSelectedFilters(filter.customer_status);
        setCustomerSelectedFilters(filter.customer_name);
        setCurrentPage(page.current);
        setPageSize(page.pageSize);
    };

    const handleAdditionalSave = (row) => { 
        const newData = [...addContactDetails];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
        ...item,
        ...row,
        });
        setAddContactDetails(newData);
    }

    const handleSave = (row) => {
        // assign appropriate default values when only spaces are entered to prevent editable cell from dissapearing

        for (const key in row) 
            {
              let keyValue = String(row[key]);

              switch (key) {
                case "customer_name":
                  if (!keyValue.replace(/\s/g, '').length) 
                    {
                      row[key] = "-";
                    }
                  break;

                case "customer_registration_number":
                if (!keyValue.replace(/\s/g, '').length) 
                  {
                    row[key] = "-";
                  }
                break;

                case "customer_address":
                if (!keyValue.replace(/\s/g, '').length) 
                  {
                    row[key] = "-";
                  }
                break;

                case "customer_vat_number":
                  if (!keyValue.replace(/\s/g, '').length) 
                    {
                      row[key] = "0";
                    }
                  break;

                case "customer_email_address":
                  if (!keyValue.replace(/\s/g, '').length) 
                    {
                      row[key] = "-";
                    }
                  break;

                case "customer_additional_contact_name":
                if (!keyValue.replace(/\s/g, '').length) 
                {
                    row[key] = "-";
                }
                break;

                case "customer_additional_contact_number":
                if (!keyValue.replace(/\s/g, '').length) 
                {
                    row[key] = "-";
                }
                break;

                case "customer_additional_contact_email":
                if (!keyValue.replace(/\s/g, '').length) 
                {
                    row[key] = "-";
                }
                break;
              
                default:
                  break;
              }
              
            }

        const newData = [...tableDataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
        ...item,
        ...row,
        });
        setDataSource(newData);
    }

    function populateUI()
    {
        try 
        {
            AxiosHelper.makeAxiosRequest("Read", "User", "GetUsers", null, null)
            .then((response) =>{
                let userIds = [];
                let users = response.data;
                users.forEach(user =>{
                    userIds.push(user.userId);
                })
                const options = users.map((item)=>{
                    return { name: item.firstName + " " + item.surname, id: item.userId }
                });
                
                options.push({name:"-", id:-1});
                setAccountManagerDropdownOptions(options);

                AxiosHelper.makeAxiosRequest("Read", "Customer", "GetCustomers", null, null)
                .then((response) => {
                    let tempFilters = [];
                    let tempKeys = [];
                    const tempData = [];
                    console.log(response.data)
                    response.data.forEach(element => {
                        let accountManagerName = options.find(user => user.id === element.UserId).name;
    
                        if(tempFilters.findIndex(item => item.value === element.CustName)===-1){
                            tempFilters.push({
                              text: element.CustName,
                              value: element.CustName,
                            });
                          }
                          tempKeys.push({
                            key: element.CustId
                          });

                        tempData.push({
                            key:element.CustId,
                            customer_name: element.CustName,
                            customer_account_manager: element.UserId,
                            customer_account_manager_name: accountManagerName,
                            customer_email_address: element.CustEmail,
                            customer_address:element.CustAddress,
                            customer_registration_number: element.CustRegNo,
                            customer_vat_number: element.CustVatNo,
                            customer_payment_term_id: element.CustPaymentTermId,
                            customer_payment_terms: element.CustPaymentTerm.PaymentTermDescription,
                            customer_status:element.CustStatus,
                            customer_additional_contact_name:element.CustAdditionalContactName,
                            customer_additional_contact_number:element.CustAdditionalContactNo,
                            customer_additional_contact_email:element.CustAdditionalContactEmail,
                            customer_type : "Server",
                        })
                    });
                    setCustomerFilter(tempFilters);
                    setDataSource(tempData);
    
                    AxiosHelper.makeAxiosRequest("Read", "Customer", "GetPaymentTerm", null, null)
                    .then((response) => {
                        setPaymentTerms(response.data);
                    })
                    .catch(error => {
                        console.log(error);
                    }
                    )
                });
            })
        } 
        catch (error) 
        {
            console.log(error);
        }
    }

    const handleDeleteModalClose = () => setDeleteModalShow(false);

    function handleDeleteModalShow(customerRecord)
    {
        setSelectedDeleteCustomer(customerRecord);
        setDeleteModalShow(true);
    }

    const handleAdditionalContactDeleteModalClose = () => setAdditionalContactDeleteModalShow(false);

    function handleAdditionalContactDeleteModalShow(additionalContact)
    {
        setSelectedDeleteAdditionalContact(additionalContact);
        setAdditionalContactDeleteModalShow(true);
    }

    const handleCustomerAdd = () =>{
        onTableDataChange(true);
        let newRowKey = GetNewRowKey(tableDataSource);
        const newData = {
            customer_account_manager: -1,
            customer_address : "-",
            customer_email_address : "-",
            customer_name : "-",
            customer_payment_term_id : 1,
            customer_payment_terms : "30",
            customer_registration_number : "-",
            customer_status : "Active",
            customer_vat_number : "-",
            key : newRowKey,
            customer_type : "Client",
        };

        const newLines = [...tableDataSource];
        newLines.push(newData);

        //calculate focus page in table
        let tempCurrentPage = Math.floor(newLines.length/pageSize)+1;
        setCurrentPage(tempCurrentPage);
        setDataSource(newLines);
    }

    function onCustomerDelete(customer)
    {
        //Remove additional contacts in state for this customer
        const tempAdditionalContacts = [];
        additionalContacts.forEach(contact=>{
            if(contact.customerId!==customer.key){
                tempAdditionalContacts.push(contact);
            }
        })
        setAdditionalContacts(tempAdditionalContacts);
        //delte customer from table
        let tableDataCopy = [...tableDataSource];
        let deleteTableDataIndex = tableDataCopy.findIndex(x => x.key === customer.key);
        if(customer.customer_type==="Server")
        {
            AxiosHelper.makeAxiosRequest("Delete", "Customer", "DeleteCustomer", {customerId: customer.key, currentUserId: loggedInUser}, null)
                .then((response) => {
    
                    if (response.data === "Customer Deleted") 
                    {
                        //populateUI();
                        tableDataCopy.splice(deleteTableDataIndex, 1);
                        setDataSource(tableDataCopy);
                        notifySuccessful("Customer Deleted!");
                        handleDeleteModalClose(); 
                    }
                    else
                    {
                        notifyFailed("Customer has proposals loaded.");
                        handleDeleteModalClose();
                    }
                })
                .catch(error => {
                    console.log(error);
                    notifyFailed("An Error Occurred, Please Try Again.");
                    handleDeleteModalClose();
                });  
        }
        else{
            tableDataCopy.splice(deleteTableDataIndex, 1);
            setDataSource(tableDataCopy);
            notifySuccessful("Customer Deleted!");
            handleDeleteModalClose(); 
        }
    }

    const notifySuccessful = (message) => {
        toast.success(message, {
          position: "bottom-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
    };
    
    const notifyFailed = (message) => {
        toast.error(message, {
          position: "bottom-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
    };

    function sendEmail(customer,currCustomerContacts) {
        let user = getTokenUser();
        let message = {};
        if(currCustomerContacts !== undefined){
            message = {
                toEmails: [ACCOUNT_EMAIL, user.email],
                subject: "New customer created: " + customer.CustName,
                body: "A new customer has been added on the BCI Finance App." +
                    "<br><b>Name:</b> "+ customer.CustName +
                    "<br><b>Email Address:</b> "+ customer.CustEmail +
                    "<br><b>Address:</b> "+ customer.CustAddress +
                    "<br><b>Registration Number:</b> "+ customer.CustRegNo +
                    "<br><b>Vat Number:</b> "+ customer.CustVatNo +
                    "<br><b>Contact Person:</b> "+ currCustomerContacts.additional_contact_full_name +
                    "<br><b>Contact No:</b> "+ currCustomerContacts.additional_contact_mobile_number +
                    "<br><b>Contact Person Email:</b> "+ currCustomerContacts.additional_contact_email_address +
                    "<br><br>This customer was created by: "+ getTokenEmail()
            }
        }else{
            message = {
                toEmails: [ACCOUNT_EMAIL, user.email],
                subject: "New customer created: " + customer.CustName,
                body: "A new customer has been added on the BCI Finance App." +
                    "<br><b>Name:</b> "+ customer.CustName +
                    "<br><b>Email Address:</b> "+ customer.CustEmail +
                    "<br><b>Address:</b> "+ customer.CustAddress +
                    "<br><b>Registration Number:</b> "+ customer.CustRegNo +
                    "<br><b>Vat Number:</b> "+ customer.CustVatNo +
                    "<br><br>This customer was created by: "+ getTokenEmail()
            }
        }
        
        AxiosHelper.makeAxiosRequest("Create", "Email", "Send", null, message)
        .catch(error => {
            console.log(error)
        })
    }

    function validate(){
        let valid = true;
        tableDataSource.forEach(customer=>{
            if(customer.customer_name==="-"||customer.customer_account_manager===-1||customer.customer_account_manager_name==='-'||customer.customer_address==="-"||customer.customer_registration_number==="-"||customer.customer_vat_number==="-"||customer.customer_email_address==="-"){
                valid=false;
            } 

            //valid email
            if(!(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(customer.customer_email_address))){
                valid=false;
            }

            //testing duplicate names
            if (tableDataSource.filter((tableCustomer) => tableCustomer.customer_name === customer.customer_name).length > 1) {
                valid = false;
            }
            
        })
        return valid;
    }


    function SaveTable()
    {
        try {
            if(validate()){
            let tempCustomer={}
            tableDataSource.forEach(customer=>{
                if(customer.customer_type==="Client"){
                    //customer object to be created in database
                    let createdCustomer = {
                        UserId: Number(customer.customer_account_manager),
                        CustStatus: customer.customer_status,
                        CustName: customer.customer_name,
                        CustAddress: customer.customer_address,
                        CustRegNo: customer.customer_registration_number,
                        CustVatNo: customer.customer_vat_number,
                        CustEmail: customer.customer_email_address,
                        CustPaymentTermId: Number(customer.customer_payment_term_id),
                    }

                    //create object of all additional contacts that will be added to database for this customer
                    const currCustomerContacts = [];
                    additionalContacts.forEach(contact =>{
                        if(contact.customerId === customer.key){
                            currCustomerContacts.push({
                                additional_contact_full_name: contact.additionalContactFullName,
                                additional_contact_mobile_number: contact.additionalContactMobileNumber,
                                additional_contact_email_address: contact.additionalContactEmailAddress,
                                additional_contact_type: contact.additionalContactType,
                                additional_contact_customer_key: customer.key
                            })
                        }
                    })
                    

                    //create new customer
                    AxiosHelper.makeAxiosRequest("Create", "Customer", "CreateNewCustomer", {currentUserId: loggedInUser}, createdCustomer)
                    .then((response) => {
                        //Create additional contacts for this new customer
                        currCustomerContacts.forEach(element => {
                            if(element.additional_contact_full_name !== '-'){
                                let tempAddContact = {
                                    CustomerId:response.data.custId,
                                    AdditionalContactFullName:element.additional_contact_full_name,
                                    AdditionalContactMobileNumber:element.additional_contact_mobile_number,
                                    AdditionalContactEmailAddress:element.additional_contact_email_address,
                                    AdditionalContactType:element.additional_contact_type
                                }

                                AxiosHelper.makeAxiosRequest("Create", "Customer", "SaveAdditionalContact", {currenUserId: loggedInUser}, tempAddContact)
                                .then((response) => {
                                    populateUI();
                                }).catch(error=>{
                                    console.log(error)
                                });
                            }
                        });
                        //remove currCustomerContacts from state since keys change after save
                        const tempAdditionalContacts = [];
                        additionalContacts.forEach(contact=>{
                            if(currCustomerContacts.findIndex((item)=>item.additional_contact_customer_key===contact.customerId)===-1){
                                tempAdditionalContacts.push(contact);
                            }
                        })
                        setAdditionalContacts(tempAdditionalContacts);

                        sendEmail(createdCustomer,currCustomerContacts[0]);
                        setTimeout(function () {
                            navigate('/customerlistview');
                        }, 2000);
                    })
                    .catch(error => {
                        console.log(error);
                        notifyFailed("An Error Occured, Please Try Again.");
                    });
                    
                }else{
                    tempCustomer = {
                        CustId: customer.key,
                        UserId: Number(customer.customer_account_manager),
                        CustName: customer.customer_name,
                        CustRegNo: customer.customer_registration_number,
                        CustAddress: customer.customer_address,
                        CustVatNo: customer.customer_vat_number,
                        CustEmail: customer.customer_email_address,
                        CustPaymentTermId: customer.customer_payment_term_id,
                        CustStatus: customer.customer_status,
    
                        CustAdditionalContactName: customer.customer_additional_contact_name,
                        CustAdditionalContactNo: customer.customer_additional_contact_number,
                        CustAdditionalContactEmail: customer.customer_additional_contact_email,
                    }
                    const currUserId = loggedInUser;
                    AxiosHelper.makeAxiosRequest("Create", "Customer", "UpdateCustomer", {currentUserId: currUserId}, tempCustomer)
                    .then(()=>{
                        populateUI();
                    }).catch((Error)=>{
    
                        if(Error === 'ValidationError'){
                            console.log(Error);
                        }
    
                        console.log(Error);
                        notifyFailed("An Error Occurred, Please Try Again.")
                    });
                }
            })
            onTableDataChange(false);
            notifySuccessful("Customer Created / Changes Saved");
        }else{
            notifyFailed("Please complete all Customer details, including contact details!");
        }
            

        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    function getCustomerAdditionalContacts(customer)
    {
        let tempData = [];
        try 
        {
            if(customer.customer_type==="Server")
            {
                AxiosHelper.makeAxiosRequest("Read", "Customer", "GetAdditionalContacts", {CustId: customer.key})
                .then((response) => {
                    response.data.forEach(element => {
                        tempData.push({
                            key: element.additionalContactId,
                            additional_contact_full_name: element.additionalContactFullName,
                            additional_contact_mobile_number: element.additionalContactMobileNumber,
                            additional_contact_email_address: element.additionalContactEmailAddress,
                            additional_contact_type: element.additionalContactType
                        });
                    });
                    
                    setAddContactDetails(tempData);
                });
    
                handleManageAdditionalContactsModalShow(customer);
                setCurrentCustomerExist(true);
            }
            else{
                //notifyFailed("Please save the new Customer before adding additional contacts.");
                const tempAdditionalContact = [];
                additionalContacts.forEach(contact =>{
                    if(contact.customerId === customer.key){
                        tempAdditionalContact.push({
                            key: contact.key,
                            additional_contact_full_name: contact.additionalContactFullName,
                            additional_contact_mobile_number: contact.additionalContactMobileNumber,
                            additional_contact_email_address: contact.additionalContactEmailAddress,
                            additional_contact_type: contact.additionalContactType
                        });
                    }
                })
                setAddContactDetails(tempAdditionalContact);
                handleManageAdditionalContactsModalShow(customer);
                setCurrentCustomerExist(false);
            }    
        }       
        catch (error) 
        {
            console.log(error);
        }
    }

    function clearCustomerAdditionalContactsChanges()
    {
        let tempData = [];

        try 
        {
            AxiosHelper.makeAxiosRequest("Read", "Customer", "GetAdditionalContacts", {CustId: selectedManageCustomerAdditionalContacts.key})
            .then((response) => {
                
                response.data.forEach(element => {
                    tempData.push({
                        key: element.additionalContactId,
                        additional_contact_full_name: element.additionalContactFullName,
                        additional_contact_mobile_number: element.additionalContactMobileNumber,
                        additional_contact_email_address: element.additionalContactEmailAddress
                    });
                });
                
                setAddContactDetails(tempData);
                handleCustomerAdditionalContactsCancelModalClose()
                notifySuccessful("Changes Successfully Cleared!");
            });

        } 
        catch (error) 
        {
            console.log(error);
        }
    }

    //#endregion

    //#region region UI Population
    
    React.useEffect(()=>{
        if(!canAccessPage('Customer')){
            navigate('/login');
        }
        populateUI();

    },[]);

      const notifyChanges = (message) => {
        toast.warning(message, {
            toastId: "ToastDataTableWarning",
            position: "top-right",
            autoClose: false,
            closeOnClick: true,
            draggable: false,
            progress: undefined,
            closeButton: true
          });
        };

      function onTableDataChange(isDirty)
        {
          if (isDirty) 
          {
            notifyChanges("Data table contains unsaved changes.");
          }
          else
          {
            toast.dismiss();
          }
        }

        const handleCancelModalClose = () => setCancelModalShow(false);
        const handleCancelModalShow = () => setCancelModalShow(true);

        function onCancelChanges()
        {
            populateUI();
            onTableDataChange(false);
            notifySuccessful("Changes Successfully Cleared!");
            handleCancelModalClose();
        }

        const handleManageAdditionalContactsModalClose = () => setManageAdditionalContactsModalShow(false);
        function handleManageAdditionalContactsModalShow (selectedCustomer)
        {
            setSelectedManageCustomerAdditionalContacts(selectedCustomer);
            setManageAdditionalContactsModalShow(true);
        }

        const handleCustomerAdditionalContactsCancelModalClose = () => setCancelCustomerAdditionalContactsModalShow(false);
        const handleCustomerAdditionalContactsCancelModalShow = () => setCancelCustomerAdditionalContactsModalShow(true);

    //#endregion 

    return(
        <div>

            {/* Confirm Delete Modal */}

            <Modal centered show={deleteModalShow} onHide={handleDeleteModalClose}>

                <Modal.Header closeButton>
                <Modal.Title>Delete Customer</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                <div style={{display: "flex", flexDirection: "column"}}>
                    <div>
                        <p className="p-main">
                            Are you sure you want to delete the following customer?
                            <br />
                            This change can not be reversed.
                        </p>
                    </div>
                    <div>
                        <p className="p-main">{selectedDeleteCustomer.customer_name}</p>
                    </div>
                </div>
                </Modal.Body>

                <Modal.Footer>
                <Button variant="primary" onClick={handleDeleteModalClose}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={() => onCustomerDelete(selectedDeleteCustomer)}>
                    Delete Customer
                </Button>
                </Modal.Footer>

            </Modal>

            {/* Confirm Additional Contact Delete Modal */}

            <Modal centered show={additionalContactDeleteModalShow} onHide={handleAdditionalContactDeleteModalClose}>

                <Modal.Header closeButton>
                <Modal.Title>Delete Customer Additional Contact</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                <div style={{display: "flex", flexDirection: "column"}}>
                    <div>
                        <p className="p-main">
                            Are you sure you want to delete the following additional contact?
                            <br />
                            This change can not be reversed.
                        </p>
                    </div>
                    <div>
                        <p className="p-main">{selectedDeleteAdditionalContact.additional_contact_full_name}</p>
                    </div>
                </div>
                </Modal.Body>

                <Modal.Footer>
                <Button variant="primary" onClick={handleAdditionalContactDeleteModalClose}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={() => onAdditionalContactDelete(selectedDeleteAdditionalContact)}>
                    Delete Additional Contact
                </Button>
                </Modal.Footer>

            </Modal>

            {/* Confirm Customer Cancel Modal */}

            <Modal centered show={cancelModalShow} onHide={handleCancelModalClose}>

                <Modal.Header closeButton>
                    <Modal.Title>Clear Changes</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <div>
                            <p className="p-main">
                                Are you sure you want to clear any changes made?
                                <br />
                                This does not include items that have been deleted.
                            </p>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleCancelModalClose}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={onCancelChanges}>
                        Clear Changes
                    </Button>
                </Modal.Footer>

            </Modal>

            {/* Confirm Additional Contact Cancel Modal */}

            <Modal centered show={cancelCustomerAdditionalContactsModalShow} onHide={handleCustomerAdditionalContactsCancelModalClose}>

                <Modal.Header closeButton>
                    <Modal.Title>Clear Changes</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <div>
                            <p className="p-main">
                                Are you sure you want to clear any changes made?
                                <br />
                                This does not include items that have been deleted.
                            </p>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleCustomerAdditionalContactsCancelModalClose}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={clearCustomerAdditionalContactsChanges}>
                        Clear Changes
                    </Button>
                </Modal.Footer>

            </Modal>

            {/* Manage Additional Contacts Modal */}

            <Modal size="lg" centered show={manageAdditionalContactsModalShow} onHide={handleManageAdditionalContactsModalClose}>

                <Modal.Header closeButton>
                <Modal.Title>{selectedManageCustomerAdditionalContacts.customer_name} - Contacts</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                <div id="listview-body">
                    <div className={tableSize}>
                        <div id="home-table-container">
                            <Table 
                                id="home-table" 
                                pagination={{
                                    position: ["bottomCenter"],
                                    showSizeChanger: true,
                                    defaultPageSize: 5,
                                    hideOnSinglePage: false,
                                    pageSizeOptions: [5 , 10, 20, 50, 100]
                                  }} 
                                bordered="true"
                                components={components} 
                                columns={AdditionalContactColumns}
                                dataSource={addContactDetails}
                                rowClassName="row-class-test"
                                footer={() => (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <Button onClick={handleAdditionalContactAdd}>Add</Button>
                                      <div style={{ display: "flex", gap: "20px" }}>
                                        <Button
                                          variant="danger"
                                          onClick={handleCustomerAdditionalContactsCancelModalShow}
                                          style={{ alignSelf: "right" }}
                                        >
                                          Clear Changes
                                        </Button>
                                        <Button
                                          variant="success"
                                          onClick={handleCustomerAdditionalContactSave}
                                          style={{ alignSelf: "right" }}
                                        >
                                          Save Changes
                                        </Button>
                                      </div>
                                    </div>
                                  )}
                                >
                            </Table>
                        </div>
                    </div>
                </div>
                </Modal.Body>

                <Modal.Footer>
                <Button variant="primary" onClick={handleManageAdditionalContactsModalClose}>
                    Cancel
                </Button>
                </Modal.Footer>

            </Modal>

            <ToastContainer />

            <NavBar/>

            <div id="listview-body">
                    <h1>Customers</h1>
                    <div className={tableSize}>
                        <div id="home-table-container">
                            <Table 
                                id="home-table" 
                                pagination={{
                                    position: ["bottomCenter"],
                                    showSizeChanger: true,
                                    defaultPageSize: pageSize,
                                    current: currentPage,
                                    hideOnSinglePage: true,
                                    pageSizeOptions: [5 , 10, 20, 50, 100]
                                  }} 
                                bordered="true"
                                components={components} 
                                columns={customerColumns} 
                                dataSource={tableDataSource}
                                onChange={onChange}
                                rowClassName="row-class-test"
                                footer={() => (
                                    <div style={{display: "flex", justifyContent: "space-between"}}>
                                            <div>
                                              <Button onClick={handleCustomerAdd}>
                                                Add
                                              </Button>
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "right", gap: "20px" }}>
                                              <Button
                                                variant="danger"
                                                onClick={handleCancelModalShow}
                                              >
                                                  Clear Changes
                                              </Button>
                                              <Button
                                                  onClick={SaveTable}
                                                  variant="success"
                                              >
                                                  Save Changes
                                              </Button>
                                            </div>
                                          </div>
                                  )}>
                            </Table>
                        </div>
                    </div>
                </div>

            

        </div>
    )
}

export default CustomerListView